
































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { findByKey } from "@/utils/common";
import {
  getSchoolList,
  getTerm,
  getAttendance,
  getAttendanceDetail,
} from "@/api/workspace";
import Empty from "@/components/empty.vue";
import Navigate from "@/components/navigate.vue";
@Component({
  components: {
    Empty,
    Navigate,
  },
  filters: {
    statusFilter(status: number) {
      switch (status) {
        case 2:
          return "已出勤";
        case 0:
          return "待出勤";
        case 1:
          return "请假";
        case 3:
          return "迟到";
        case 4:
          return "外勤";
        case -1:
          return "缺勤";
        default:
          return "/";
      }
    },
    typeFilter(type: number) {
      switch (type) {
        case 0:
          return "正常打卡";
        case 1:
          return "系统补签";
        default:
          return "/";
      }
    },
    signTimeFilter(time: string) {
      if (time) return time.split(" ")[1];
      else return "/";
    },
  },
})
export default class AttendancePage extends Vue {
  navigate: any = [
    { name: "首页", url: "/course" },
    { name: "教师工作台", url: "/workspace" },
    { name: "出勤统计", isCurrent: true },
  ];

  termList: any = [];
  schoolList: any = [];

  currentTerm: string = "";
  currentSchool: string = "";

  attendanceInfo: any = {};

  attendanceList: any = [];
  totalAttendance: number = 0;
  pageNo: number = 1;
  pageSize: number = 15;
  keywords: string = "";

  status: string | null = null;
  type: string | null = null;
  month: string | null = null;
  sortFields: string | null = null;

  get getTeacher() {
    const teacherInfo = this.$store.state.UserModule.userInfo;
    const teacherFamilyName = teacherInfo?.name || "";
    return teacherFamilyName;
  }

  get currentTermInfo() {
    return findByKey(this.termList, { id: this.currentTerm }, false);
  }

  get termMonthList() {
    let month = moment(this.currentTermInfo?.defaultStartDate);
    const endMonth = moment(this.currentTermInfo?.defaultEndDate);
    const list: any = [{ month: null, monthName: "全部月份" }];
    while (month.unix() <= endMonth.unix()) {
      list.push({
        month: month.format("YYYY-MM"),
        monthName: month.format("YYYY年MMM"),
      });
      month.add(1, "month");
    }
    return list;
  }

  get attendanceTypeList() {
    return [
      { type: null, typeName: "全部考勤类型" },
      { type: "0", typeName: "正常打卡" },
      { type: "1", typeName: "系统补签" },
    ];
  }

  get attendanceStatusList() {
    return [
      { status: null, statusName: "全部出勤类型" },
      { status: "2", statusName: "到勤" },
      { status: "-1", statusName: "缺勤" },
      { status: "1", statusName: "请假" },
      { status: "3", statusName: "迟到" },
      { status: "4", statusName: "外勤" },
    ];
  }

  get tableHeadStyle() {
    return {
      backgroundColor: "#F6F7FB",
      textAlign: "center",
      color: "#666666",
      fontWeight: "normal",
      padding: "2rem 0",
      fontSize: "1.6rem",
    };
  }

  get tableCellStyle() {
    return {
      textAlign: "center",
      color: "#010101",
      fontSize: "1.6rem",
      padding: "3rem 0",
    };
  }

  get pageSizeList() {
    return [15, 25, 50, 100];
  }

  mounted() {
    moment.locale("zh-CN");
    this.initSchoolAndTerm()
      .then((data) => {
        this.termList = data[0] || [];
        if (this.termList.length > 0) {
          this.termList.forEach((term: any) => {
            if (term.curTerm) this.currentTerm = term.id;
          });
        }
        this.schoolList = data[1] || [];
        if (this.schoolList.length > 0) {
          this.currentSchool = this.schoolList[0].schoolId;
        }
        this.getAllAttendance();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async initSchoolAndTerm() {
    return Promise.all([await getTerm(), await getSchoolList()]);
  }

  getAttendace() {
    const params = {
      schoolId: this.currentSchool,
      termId: this.currentTerm,
    };
    getAttendance(params).then((data) => {
      this.attendanceInfo = data;
    });
  }

  keywordsChange() {
    if (this.keywords.length == 0) {
      this.searchAttendanceDetail();
    }
  }

  searchAttendanceDetail() {
    this.pageNo = 1;
    this.getAttendanceDetail();
  }

  getAttendanceDetail() {
    if (this.currentSchool && this.currentTerm) {
      const params: any = {
        schoolId: this.currentSchool,
        termId: this.currentTerm,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      if (this.status) params.attendanceStatus = this.status;
      if (this.type) params.attendanceType = this.type;
      if (this.keywords) params.name = this.keywords;
      if (this.month) params.month = this.month;
      if (this.sortFields) params.sortFields = this.sortFields;
      getAttendanceDetail(params).then((data: any) => {
        this.attendanceList = data.records;
        this.totalAttendance = parseInt(data.total);
      });
    }
  }

  getAllAttendance() {
    this.pageNo = 1;
    this.getAttendace();
    this.getAttendanceDetail();
  }

  schoolSelect(ev: any) {
    this.currentSchool = ev;
    this.getAllAttendance();
  }
  termSelect(ev: any) {
    this.currentTerm = ev;
    this.month = this.termMonthList[0].month;
    this.getAllAttendance();
  }
  monthSelect(ev: any) {
    this.month = ev;
    this.searchAttendanceDetail();
  }
  typeSelect(ev: any) {
    this.type = ev;
    this.searchAttendanceDetail();
  }
  statusSelect(ev: any) {
    this.status = ev;
    this.searchAttendanceDetail();
  }
  pageSizeSelect(ev: any) {
    this.pageSize = ev;
    this.searchAttendanceDetail();
  }
  pageChange(ev: any) {
    this.pageNo = ev;
    this.getAttendanceDetail();
  }
  sortByTime(ev: any) {
    if (ev.order == "descending")
      this.sortFields = encodeURIComponent("sign_time desc");
    else if (ev.order == "ascending")
      this.sortFields = encodeURIComponent("sign_time asc");
    else this.sortFields = null;
    this.searchAttendanceDetail();
  }
}
